import React, { PureComponent } from 'react';

import CoreUtils from '../utils/CoreUtils';

export default class BooleanEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.onControlValueListener = this.onControlValueChanged.bind(this);
  }

  render() {
    return (
      <input
        title={this.props.tooltip || ''}
        className="pwx-boolean-editor"
        disabled={this.props.disabled}
        checked={this.props.value}
        height={this.props.height}
        name={this.props.name}
        onChange={this.onControlValueListener}
        type="checkbox"
        width={this.props.width}
      />
    );
  }

  onControlValueChanged(event) {
    var value = event.currentTarget.checked;
    if (CoreUtils.isDefinedAndNotNull(this.props.postEditFilter))
      value = this.props.postEditFilter(value);

    if (CoreUtils.isDefinedAndNotNull(this.props.onValueChanged))
      this.props.onValueChanged(this.props.name, value);
  }
}